<template>
  <div class="week-slider-btn">
    <v-btn
      variant="flat"
      rounded="circle"
      color="#dbeafe"
      size="x-small"
      @click="weekLeft"
    >
      <svg-icon :svgData="svgData"/>
    </v-btn>
  </div>
</template>
<script>
import SvgIcon from '@/components/content/SvgIcon.vue'
import { useEventsStore } from '@/store/events'

export default {
  name: 'WeekSliderBtnLeft',
  components: {
    SvgIcon
  },
  data () {
    return {
      svgData: {
          width: "5",
          height: "8",
          viewBox: "0 0 5 8",
          pathArr: [{
              d: "M4.89499 1.44984L4.11165 0.666504L0.77832 3.99984L4.11165 7.33317L4.89499 6.54984L2.35054 3.99984L4.89499 1.44984Z",
              fill: "#0075AA"
          }]
      }
    }
  },
  methods:{
    weekLeft(){
      let eventsStore = useEventsStore()
      eventsStore.weekLeft()
    }
  }
}
</script>
